import React from 'react';

import styles from './ProjectNotesList.module.scss';
import { ProjectNote } from 'nekst-api';
import { useShowContextRequired } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import { ShadcnBadge } from 'shadcn-ui';

export default function IsAddedToClientPortalField() {
  const context = useShowContextRequired<ProjectNote>();
  const { isShadcnUiEnabled } = useFeatureToggleService();

  const data = context.data;

  if (data.isAddedToClientPortal) {
    if (isShadcnUiEnabled()) {
      return (
        <div className="mt-1">
          <ShadcnBadge variant="blue">Client Portal</ShadcnBadge>
        </div>
      );
    } else {
      return (
        <div className={styles.clientPortalField}>
          Client Portal
        </div>
      );
    }
  } else {
    return null;
  }
}
